import { render, staticRenderFns } from "./textCmp.vue?vue&type=template&id=71781050&scoped=true&"
import script from "./textCmp.vue?vue&type=script&lang=js&"
export * from "./textCmp.vue?vue&type=script&lang=js&"
import style0 from "./textCmp.vue?vue&type=style&index=0&id=71781050&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71781050",
  null
  
)

export default component.exports